import { render, staticRenderFns } from "./dettaglioCiclismo.vue?vue&type=template&id=4bf75be5"
import script from "./dettaglioCiclismo.vue?vue&type=script&lang=js"
export * from "./dettaglioCiclismo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports